import { gql } from '@apollo/client'

export const PaymentFragment = gql`
  fragment PaymentFragment on Payment {
    id
    amountTotalCents
    currency
    type
    stripeStatus
    brand {
      id
    }
    collaboration {
      id
    }
  }
`

export const CREATE_TIP_PAYMENT = gql`
  mutation CreateTipPayment($brandId: Int!, $creatorId: Int!, $amount: Int!) {
    createTipPayment(
      brandId: $brandId
      creatorId: $creatorId
      amount: $amount
    ) {
      ...PaymentFragment
    }
  }
  ${PaymentFragment}
`
